// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37cr7","comment":"styles_comment__3KVQy"};